import React from 'react';
import { Alert, Box, Typography, Button } from '@mui/material';
import { Lock, ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

/**
 * Standardized permission denied banner component
 * Used consistently across the site when users don't have required permissions
 */
const PermissionDeniedBanner = ({ 
  title = "Access Restricted",
  message = "You don't have permission to access this feature.",
  showBackButton = true,
  backButtonText = "Go Back",
  backButtonPath = "/supplier/dashboard",
  severity = "warning",
  icon = <Lock size={24} weight="regular" />,
  sx = {}
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(backButtonPath);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '400px',
      p: 3,
      ...sx 
    }}>
      <Box sx={{ 
        maxWidth: 500, 
        width: '100%',
        textAlign: 'center'
      }}>
        <Alert 
          severity={severity}
          icon={icon}
          sx={{ 
            mb: 3,
            '& .MuiAlert-message': {
              width: '100%'
            }
          }}
        >
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {message}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Please contact your manager or business owner if you need access to this feature.
            </Typography>
          </Box>
        </Alert>
        
        {showBackButton && (
          <Button
            variant="outlined"
            startIcon={<ArrowLeft size={20} />}
            onClick={handleGoBack}
            sx={{ 
              px: 3,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            {backButtonText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PermissionDeniedBanner;





























